var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.159,
    height: 30.189,
    viewBox: "0 0 33.159 35.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-14.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(14.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12320",
    "data-name": "Path 12320",
    d: "M47.739,9.523,38.774.207A.677.677,0,0,0,38.286,0H24.925a2.714,2.714,0,0,0-2.712,2.711v9.47H16.8a2.031,2.031,0,0,0-2.029,2.028V24.363A2.031,2.031,0,0,0,16.8,26.392h5.415v6.091a2.712,2.712,0,0,0,2.712,2.706H45.216a2.711,2.711,0,0,0,2.712-2.7V9.992A.677.677,0,0,0,47.739,9.523Zm-9.285-7.7,7.359,7.647H38.454ZM16.8,25.038a.676.676,0,0,1-.675-.675V14.209a.676.676,0,0,1,.675-.675H35.072a.676.676,0,0,1,.675.675V24.363a.676.676,0,0,1-.675.675Zm29.776,7.446a1.356,1.356,0,0,1-1.358,1.351H24.925a1.357,1.357,0,0,1-1.358-1.353V26.392H35.072A2.031,2.031,0,0,0,37.1,24.363V14.209a2.031,2.031,0,0,0-2.029-2.028H23.566V2.711a1.359,1.359,0,0,1,1.358-1.357H37.1v8.8a.677.677,0,0,0,.677.677h8.8Z",
    transform: "translate(-14.769 0)",
    fill: "#ea356f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(18.743 16.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12321",
    "data-name": "Path 12321",
    d: "M76.712,241a1.524,1.524,0,0,0-.837-.569,6.831,6.831,0,0,0-1.4-.087H72.6v5.813H73.77v-2.193h.765a6.7,6.7,0,0,0,1.217-.083,1.7,1.7,0,0,0,.609-.276,1.594,1.594,0,0,0,.494-.573,1.9,1.9,0,0,0,.194-.9A1.8,1.8,0,0,0,76.712,241Zm-1.005,1.6a.77.77,0,0,1-.367.285,3.034,3.034,0,0,1-.928.091H73.77v-1.649h.567a5.637,5.637,0,0,1,.845.04.811.811,0,0,1,.472.258.751.751,0,0,1,.186.523A.781.781,0,0,1,75.707,242.6Z",
    transform: "translate(-72.596 -240.346)",
    fill: "#ea356f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(24.156 16.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12322",
    "data-name": "Path 12322",
    d: "M156.029,241.934a2.54,2.54,0,0,0-.555-.942,1.944,1.944,0,0,0-.876-.535,4.19,4.19,0,0,0-1.106-.111h-2.145v5.813h2.209a3.549,3.549,0,0,0,1.039-.123,2.062,2.062,0,0,0,.825-.464,2.563,2.563,0,0,0,.623-1.027,3.82,3.82,0,0,0,.178-1.237A4.29,4.29,0,0,0,156.029,241.934Zm-1.142,2.387a1.23,1.23,0,0,1-.307.561,1.083,1.083,0,0,1-.474.242,3.2,3.2,0,0,1-.71.056h-.876v-3.85h.527a5.318,5.318,0,0,1,.964.056,1.117,1.117,0,0,1,.543.274,1.33,1.33,0,0,1,.333.563,3.472,3.472,0,0,1,.119,1.035A3.791,3.791,0,0,1,154.887,244.321Z",
    transform: "translate(-151.346 -240.346)",
    fill: "#ea356f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(30.032 16.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12323",
    "data-name": "Path 12323",
    d: "M240.831,241.329v-.983h-3.985v5.813h1.174v-2.47h2.427v-.983H238.02v-1.376Z",
    transform: "translate(-236.846 -240.346)",
    fill: "#ea356f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.ac5cbe14148b21b853abf1766c0a3897.svg";
export { ForwardRef as ReactComponent };